import { FC, JSX } from "react";
import RegisterForm from "@/features/auth/components/RegisterForm/RegisterForm";
import { Flex, Heading, Text } from "@radix-ui/themes";
import { Link } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutes";
import AuthLayout from "@/features/auth/components/AuthLayout/AuthLayout";
import SecondImage from "@/assets/Dreamhack-33.jpg";
import AuthImage from "@/features/auth/components/AuthImage/AuthImage";

const Register: FC = (): JSX.Element => {
  return (
    <AuthLayout>
      <Flex gap="5" direction="column" justify="center">
        <Flex gap="2" direction="column">
          <Heading mb="0" as="h1" size="8">
            Create an account
          </Heading>
          <Text size="3" color="gray">
            Start exploring new job opportunities in the event industry. Create
            an account to get started.
          </Text>
        </Flex>
        <RegisterForm />
        <Flex gap="1" justify="center">
          <Text size="2" color="gray">
            Already have an account?{" "}
          </Text>
          <Text size="2">
            <Link to={siteRoutes.auth.login.path}>
              {siteRoutes.auth.login.label}
            </Link>
          </Text>
        </Flex>
      </Flex>
      <AuthImage image={SecondImage} />
    </AuthLayout>
  );
};

export default Register;
